var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSmileyYes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2979,
    cy: 15.1523,
    r: 15,
    fill: "#65CCC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9085 11.1923C10.4464 9.73011 8.06736 9.73022 6.60527 11.1923C6.25658 11.5409 6.25658 12.1063 6.60527 12.455C6.95402 12.8036 7.51939 12.8036 7.86802 12.455C8.63396 11.6891 9.88013 11.6892 10.6459 12.455C10.8203 12.6294 11.0488 12.7166 11.2772 12.7166C11.5057 12.7166 11.7343 12.6294 11.9085 12.455C12.2572 12.1063 12.2572 11.541 11.9085 11.1923ZM23.701 11.1923C22.2389 9.73022 19.8598 9.73011 18.3977 11.1923C18.049 11.5409 18.049 12.1063 18.3977 12.455C18.7464 12.8036 19.3118 12.8036 19.6604 12.455C20.4263 11.6891 21.6724 11.6891 22.4384 12.455C22.6127 12.6294 22.8412 12.7166 23.0697 12.7166C23.2981 12.7166 23.5267 12.6294 23.701 12.455C24.0496 12.1063 24.0496 11.541 23.701 11.1923ZM7.23701 15.8086H23.0703C23.5635 15.8086 23.9632 16.2083 23.9632 16.7014C23.9632 21.559 20.0112 25.511 15.1537 25.511C10.2961 25.511 6.34416 21.559 6.34416 16.7014C6.34416 16.2084 6.74388 15.8086 7.23701 15.8086ZM8.18634 17.5943C8.62621 21.0473 11.5831 23.7253 15.1537 23.7253C18.7243 23.7253 21.6811 21.0473 22.1211 17.5943H8.18634Z",
    fill: "#081731"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmileyYes);
export default __webpack_public_path__ + "static/media/ic-smiley-yes.800eb3c72b61a0cd8db0b89f0f7a7c6d.svg";
export { ForwardRef as ReactComponent };